import React from "react";
import { Box, Stack, Tab, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ApplicationsDetailsTable from "./ApplicationDetailsTable";
import { useTranslation } from "react-i18next";
import { Version } from "./apps-types";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";

/* ApplicationDetailsPage version component, 
showing a table for each platform containing 
all app versions for that platform. */
export default function VersionSection(props: {
  name: string;
  versions: Version[];
  appID: number;
  columns: string[];
  platform: string;
  isLoading: boolean;
  open: boolean;
  setOpen: any;
}) {
  const { t } = useTranslation();
  const [tab, setTab] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  return (
    <Box>
      <Stack spacing={2} paddingTop={1}>
        <Typography variant="h5">{t("Versions")}</Typography>
        {props.platform === "Android; iOS;" ? (
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab
                  label={<AppleIcon sx={{ width: 25, height: 25 }} />}
                  value="1"
                />
                <Tab
                  label={<AndroidIcon sx={{ width: 25, height: 25 }} />}
                  value="2"
                />
              </TabList>
            </Box>
            <TabPanel value="1" sx={{ p: 0, m: 0 }}>
              <ApplicationsDetailsTable
                name={props.name}
                platform="Android; iOS;"
                columns={props.columns}
                versions={props.versions.filter(
                  (item: Version) => item.platform === "IOS"
                )}
                appID={props.appID}
                isLoading={props.isLoading}
                allVersions={props.versions}
              />
            </TabPanel>
            <TabPanel value="2" sx={{ p: 0 }}>
              <ApplicationsDetailsTable
                name={props.name}
                platform="Android; iOS;"
                columns={props.columns}
                versions={props.versions.filter(
                  (item: Version) => item.platform === "ANDROID"
                )}
                appID={props.appID}
                isLoading={props.isLoading}
                allVersions={props.versions}
              />
            </TabPanel>
          </TabContext>
        ) : (
          <Box>
            <ApplicationsDetailsTable
              name={props.name}
              platform={props.platform}
              columns={props.columns}
              versions={props.versions}
              appID={props.appID}
              isLoading={props.isLoading}
            />
          </Box>
        )}
      </Stack>
    </Box>
  );
}
